export const formatCurrencyLocalized = (locale, amount, currency) => {
  if (!amount || isNaN(amount)) {
    amount = 0;
  }
  if (!currency) {
    currency = "cad";
  }

  if (locale === "fr") {
    locale = "fr-CA";
  } else if (currency === "usd") {
    locale = "en-US";
  } else {
    locale = "en-CA";
  }

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency.toUpperCase(),
    currencyDisplay: "symbol"
  }).format(amount);
};